export enum WebformTargetType {
    Unknown = 0,
    Category = 1,
    History = 2,
    ConfigCategory = 3,
    Note = 4,
}